export default "__VITE_ASSET__c26db9be__"